/**
 * @upsetjs/model
 * https://github.com/upsetjs/upsetjs
 *
 * Copyright (c) 2021 Samuel Gratzl <sam@sgratzl.com>
 */

export const SET_JOINERS = {
  distinctIntersection: ' ∩ ',
  intersection: ' ∩ ',
  union: ' ∪ ',
  composite: ',',
};
